import generalSansRegularUrl from "../../../assets/fonts/GeneralSans-Regular.ttf";
import generalSansMediumUrl from "../../../assets/fonts/GeneralSans-Medium.ttf";

export const GENERAL_SANS = "GeneralSans";

let cachedRegularBase64: string | null = null;
let cachedMediumBase64: string | null = null;
let loading: Promise<void> | null = null;

const fetchFontAsBase64 = async (url: string): Promise<string> => {
	const response = await fetch(url);
	if (!response.ok) {
		throw new Error(`Failed to load font: ${url}`);
	}

	const buffer = await response.arrayBuffer();
	const bytes = new Uint8Array(buffer);
	let binary = "";
	const chunkSize = 0x8000;
	for (let i = 0; i < bytes.length; i += chunkSize) {
		binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
	}
	return btoa(binary);
};

const loadFontBytes = async (): Promise<void> => {
	if (cachedRegularBase64 && cachedMediumBase64) {
		return;
	}

	if (!loading) {
		loading = Promise.all([
			fetchFontAsBase64(generalSansRegularUrl),
			fetchFontAsBase64(generalSansMediumUrl),
		])
			.then(([regular, medium]) => {
				cachedRegularBase64 = regular;
				cachedMediumBase64 = medium;
			})
			.finally(() => {
				loading = null;
			});
	}

	await loading;
};

/**
 * Registers General Sans on a jsPDF instance.
 * Heaviest face is medium — bold/semibold are never registered.
 */
export const ensureGeneralSansFonts = async (doc: import("jspdf").jsPDF): Promise<string> => {
	await loadFontBytes();

	doc.addFileToVFS("GeneralSans-Regular.ttf", cachedRegularBase64 as string);
	doc.addFileToVFS("GeneralSans-Medium.ttf", cachedMediumBase64 as string);
	doc.addFont("GeneralSans-Regular.ttf", GENERAL_SANS, "normal");
	doc.addFont("GeneralSans-Medium.ttf", GENERAL_SANS, "medium");
	doc.addFont("GeneralSans-Regular.ttf", GENERAL_SANS, "italic");
	doc.addFont("GeneralSans-Medium.ttf", GENERAL_SANS, "mediumitalic");

	return GENERAL_SANS;
};
